__turbopack_context__.v({
  "arc": "BgmT5W_arc",
  "art": "BgmT5W_art",
  "chip": "BgmT5W_chip",
  "chipFaint": "BgmT5W_chipFaint",
  "chipIv": "BgmT5W_chipIv",
  "chipLongevity": "BgmT5W_chipLongevity",
  "chipRecovery": "BgmT5W_chipRecovery",
  "copy": "BgmT5W_copy",
  "cta": "BgmT5W_cta",
  "cutout": "BgmT5W_cutout",
  "description": "BgmT5W_description",
  "eyebrow": "BgmT5W_eyebrow",
  "photo": "BgmT5W_photo",
  "section": "BgmT5W_section",
  "title": "BgmT5W_title",
});
